import { Role } from '@/utils/auth';
import PassThrough from '@/components/PassThrough.vue';

const AdminBase = () => import(/* webpackChunkName: "group-admin"  */ '@/pages/admin/AdminBase.vue');
const AdminContent = () => import(/* webpackChunkName: "group-admin"  */ '@/pages/admin/AdminContent.vue');
const AdminSections = () => import(/* webpackChunkName: "group-admin"  */ '@/pages/admin/AdminSections.vue');
const AdminUsers = () => import(/* webpackChunkName: "group-admin"  */ '@/pages/admin/AdminUsers.vue');
const StudentList = () => import(/* webpackChunkName: "group-admin"  */ '@/components/creator-school/StudentList.vue');
const CourseList = () => import(/* webpackChunkName: "group-admin"  */ '@/components/creator-school/CourseList.vue');
const CourseEditor = () => import(/* webpackChunkName: "group-dashboard"  */ '@/components/creator-school/CourseEditor.vue');
const AdminNoteList = () => import(/* webpackChunkName: "group-admin"  */ '@/pages/AdminNoteList.vue');

export default {
  path: '/admin',
  name: 'Admin',
  component: AdminBase,
  redirect: { name: 'AdminContent' },
  children: [
    {
      path: 'content',
      name: 'AdminContent',
      component: AdminContent,
    },
    {
      path: 'sections',
      name: 'AdminSections',
      component: AdminSections,
    },
    {
      path: 'users',
      name: 'AdminUsers',
      component: AdminUsers,
    },
    {
      path: 'school',
      name: 'AdminSchool',
      component: PassThrough,
      children: [
        {
          path: 'students',
          name: 'StudentList',
          component: StudentList,
        },
        {
          path: 'courses',
          name: 'CourseList',
          component: CourseList,
        },
        {
          path: 'notes',
          name: 'AdminNoteList',
          component: AdminNoteList,
        },
        {
          path: 'course-editor/:id',
          name: 'SchoolCourseEditor',
          component: CourseEditor,
          props: true,
        },
      ],
    },
  ],
  meta: {
    allowed: [Role.ADMIN],
  },
};
